'use client';

import { useState, useSyncExternalStore } from 'react';

import { HLSVideoPlayer } from '@/components/ui/SanityVideoPlayer';
import { IMuxVideoPlayer } from '@/sanity/globals/VideoPlayer';

// Phones keep the portrait board PNG (the clip is landscape) and never fetch the stream;
// reduced motion keeps the still.
const PLAY_MQ = '(min-width: 993px) and (prefers-reduced-motion: no-preference)';

function subscribe(onChange: () => void) {
  const mq = window.matchMedia(PLAY_MQ);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function BoardVideo({ video }: { video: IMuxVideoPlayer }) {
  const [playing, setPlaying] = useState(false);

  return (
    <HLSVideoPlayer
      source={video}
      autoPlay
      muted
      loop
      playsInline
      aria-hidden
      onPlaying={() => setPlaying(true)}
      className={`pointer-events-none absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${playing ? 'opacity-100' : 'opacity-0'}`}
    />
  );
}

export default function HeroBoardVideo({ video }: { video: IMuxVideoPlayer }) {
  const canPlay = useSyncExternalStore(
    subscribe,
    () => window.matchMedia(PLAY_MQ).matches,
    () => false,
  );

  return canPlay ? <BoardVideo video={video} /> : null;
}
